module.exports = __webpack_public_path__ + "static/img/picture9.42aa6c8e.png";